import React, { Component } from "react";
import Chip from "@material-ui/core/Chip";
import moment from "moment";
import { adToBsDate } from "../../../../utils/Utils";

class SubjectAssessmentDetailTableRow extends Component {
  state = {};
  render() {
    let sub = this.props.subject;
    return (
      <>
        {sub.hasTheory !== null && sub.hasTheory ? (
          <tr key={this.props.subjectIdx}>
            {sub.hasTheory !== null && sub.hasTheory ? (
              <>
                <td>
                  {sub.name}
                  <Chip
                    color={"default"}
                    className="override-chip"
                    label={"Theory"}
                  />
                </td>
                <td>
                  {sub.assessmentTheoryFromDate
                    ? `(${adToBsDate(sub.assessmentTheoryFromDate, true)})`
                    //  moment(sub.assessmentTheoryFromDate).format("LLL")
                    : null}{" "}
                  -{" "}
                  {sub.assessmentTheoryToDate
                    ? `(${adToBsDate(sub.assessmentTheoryToDate, true)})`
                    : null}
                </td>
                <td>
                  {sub.recordingTheoryDate
                    ? adToBsDate(sub.recordingTheoryDate)
                    : null}
                </td>
                <td>
                  {sub.recordingTheoryDeadlineDate
                    ? adToBsDate(sub.recordingTheoryDeadlineDate)
                    : null}
                </td>
              </>
            ) : null}
          </tr>
        ) : null}

        {sub.hasPractical !== null && sub.hasPractical ? (
          <tr>
            {sub.hasPractical !== null && sub.hasPractical ? (
              <>
                {sub.hasPractical ? (
                  <>
                    <td>
                      {sub.name}
                      <Chip
                        color={"default"}
                        className="override-chip"
                        label={"Practical"}
                      />
                    </td>
                    <td>
                      {sub.assessmentPracticalFromDate
                        ? `(${adToBsDate(sub.assessmentPracticalFromDate, true)})`
                        : null}{" "}
                      - {" "}
                      {sub.assessmentPracticalToDate
                        ? `(${adToBsDate(sub.assessmentPracticalToDate, true)})`
                        : null}
                    </td>
                    <td>
                      {sub.recordingPracticalDate
                        ? `${adToBsDate(sub.assessmentTheoryFromDate)}`
                        : null}
                    </td>
                    <td>
                      {sub.recordingPracticalDeadlineDate
                        ? `${adToBsDate(sub.recordingPracticalDeadlineDate)}`
                        : null}
                    </td>
                  </>
                ) : null}
              </>
            ) : null}
          </tr>
        ) : null}
      </>
    );
  }
}

export default SubjectAssessmentDetailTableRow;
